import PropTypes from 'prop-types';
import React from 'react';

import {
    Footer,
    Main,
    SideBar
} from '$partials/global';
import { Stream as ModuleStream } from '$partials/modules';
import { TextInteractive } from '$partials/modules/blocks';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Home = (props) => {
    // render
    return (
        <>
            <SideBar
                localePages={props.page?.translations?.edges}
                navigation={props.navigation}
                search={props.search}>
                {/* header */}
                <div className='container'>
                    <div className='module'>
                        <TextInteractive
                            staticText={props.page?.staticHeading}
                            text={props.page?.heading}
                            textList1={props.page?.headingList1}
                            textList2={props.page?.headingList2}
                            textList3={props.page?.headingList3}
                            textList4={props.page?.headingList4} />
                    </div>
                </div>
            </SideBar>

            <SideBar
                className='mtn9 sm-mtn9 md-mtn14'
                isHeader={false}>
                <Main className='container'>
                    {/* modules */}
                    <ModuleStream
                        modules={props.page?.modules}
                        namespace='homepage' />
                </Main>

                <Footer { ...props.footer }/>
            </SideBar>
        </>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    footer: PropTypes.object,
    navigation: PropTypes.object,
    page: PropTypes.shape({
        __typename       : PropTypes.string,
        heading          : PropTypes.string,
        staticHeading    : PropTypes.string,
        headingList1     : PropTypes.string,
        headingList2     : PropTypes.string,
        headingList3     : PropTypes.string,
        headingList4     : PropTypes.string,
        id               : PropTypes.string,
        listingImage     : PropTypes.object,
        metaImage        : PropTypes.object,
        metaKeywords     : PropTypes.string,
        modules          : PropTypes.array,
        searchDescription: PropTypes.string,
        seoTitle         : PropTypes.string,
        title            : PropTypes.string,
        translations     : PropTypes.object,
        url              : PropTypes.string
    }),
    search: PropTypes.object,
    translations: PropTypes.object,
    uri: PropTypes.string
};

Home.propTypes = propTypes;

export { Home };

export default Home;
